(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    const wishlist = window.gommaDOT?.wishlist;
    if (!wishlist) return;
    root.dataset.ready = 'true';
    const strings = JSON.parse(root.querySelector('[data-wishlist-strings]').textContent);
    const grid = root.querySelector('[data-wishlist-grid]');
    const empty = root.querySelector('[data-wishlist-empty]');
    const summary = root.querySelector('[data-wishlist-summary]');
    const errors = root.querySelector('[data-wishlist-errors]');
    const pagination = root.querySelector('[data-wishlist-pagination]');
    const prev = root.querySelector('[data-wishlist-prev]');
    const next = root.querySelector('[data-wishlist-next]');
    const cache = new Map();
    const pageSize = 12;
    let page = 1;
    let generation = 0;
    let controller;

    async function load(handle, signal) {
      if (cache.has(handle)) return cache.get(handle);
      const prefix = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const url = new URL(`${prefix}products/${encodeURIComponent(handle)}`, location.origin);
      url.searchParams.set('section_id', 'wishlist-product');
      const response = await fetch(url, { signal, credentials: 'same-origin' });
      if (response.status === 404) return { unavailable: true };
      if (!response.ok) throw new Error('Product request failed');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const wrapper = doc.querySelector('[data-wishlist-product]');
      const card = wrapper?.querySelector('.product-card');
      if (!card || wrapper.dataset.wishlistProduct !== handle) throw new Error('Product card unavailable');
      const result = { card };
      cache.set(handle, result);
      return result;
    }

    function errorCard(item, handle, unavailable) {
      item.classList.add('wishlist-item--error');
      const message = document.createElement('p');
      message.textContent = unavailable ? strings.unavailable : strings.error;
      const title = document.createElement('strong');
      title.textContent = handle.replace(/-/g, ' ');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-remove';
      remove.dataset.wishlistToggle = handle;
      remove.dataset.wishlistRemove = '';
      remove.textContent = strings.remove;
      item.replaceChildren(title, message, remove);
      if (!unavailable) {
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'button button--outline';
        retry.textContent = strings.retry;
        retry.addEventListener('click', render);
        item.append(retry);
      }
    }

    async function render() {
      controller?.abort();
      controller = new AbortController();
      const { signal } = controller;
      const currentGeneration = ++generation;
      const saved = wishlist.get().slice().reverse();
      const pages = Math.max(1, Math.ceil(saved.length / pageSize));
      page = Math.min(page, pages);
      const handles = saved.slice((page - 1) * pageSize, page * pageSize);
      summary.textContent = saved.length === 1 ? strings.countOne : strings.count.replace('__COUNT__', String(saved.length));
      empty.hidden = saved.length > 0;
      grid.hidden = saved.length === 0;
      grid.setAttribute('aria-busy', String(handles.length > 0));
      errors.hidden = true;
      pagination.hidden = pages < 2;
      prev.disabled = page === 1;
      next.disabled = page === pages;
      root.querySelector('[data-wishlist-page-label]').textContent = strings.page.replace('__PAGE__', String(page)).replace('__PAGES__', String(pages));
      const items = handles.map(() => {
        const item = document.createElement('li');
        item.className = 'wishlist-item wishlist-item--loading';
        item.textContent = strings.loading;
        return item;
      });
      grid.replaceChildren(...items);
      let cursor = 0;
      let failures = 0;
      async function worker() {
        while (cursor < handles.length && !signal.aborted) {
          const index = cursor++;
          const handle = handles[index];
          const item = items[index];
          try {
            const result = await load(handle, signal);
            if (currentGeneration !== generation) return;
            item.classList.remove('wishlist-item--loading');
            if (result.unavailable) errorCard(item, handle, true);
            else {
              const remove = document.createElement('button');
              remove.type = 'button';
              remove.className = 'wishlist-remove';
              remove.dataset.wishlistToggle = handle;
              remove.dataset.wishlistRemove = '';
              remove.textContent = strings.remove;
              item.replaceChildren(result.card.cloneNode(true), remove);
            }
            wishlist.sync();
          } catch (error) {
            if (signal.aborted || currentGeneration !== generation) return;
            item.classList.remove('wishlist-item--loading');
            errorCard(item, handle, false);
            failures++;
          }
        }
      }
      await Promise.all(Array.from({ length: Math.min(4, handles.length) }, worker));
      if (currentGeneration !== generation) return;
      grid.setAttribute('aria-busy', 'false');
      errors.hidden = failures === 0;
      document.dispatchEvent(new CustomEvent('gommadot:content-updated'));
    }

    prev.addEventListener('click', () => { page = Math.max(1, page - 1); render(); });
    next.addEventListener('click', () => { page++; render(); });
    document.addEventListener('gommadot:wishlist-updated', render);
    window.addEventListener('pageshow', (event) => { if (event.persisted) render(); });
    render();
  }
  document.querySelectorAll('[data-wishlist-page]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-wishlist-page]').forEach(init));
})();
